import { PreloadingStrategy, Route } from "@angular/router";
import { Observable, of } from "rxjs";

export class PreloadStrategy implements PreloadingStrategy {
  preload(route: Route, load: () => Observable<any>): Observable<any> {
    if (this.shouldPreloadRoute(route)) {
      return new Observable((observer) => {
        const callback = () => {
          load().subscribe({
            next: (data) => {
              observer.next(data);
              observer.complete();
            },
            error: (error) => observer.error(error),
          });
        };

        if ("requestIdleCallback" in window) {
          window.requestIdleCallback(callback);
        } else {
          setTimeout(callback, 200);
        }
      });
    } else {
      return of(null);
    }
  }

  private shouldPreloadRoute(route: Route): boolean {
    if (route.data && route?.data?.preload) {
      return true;
    }

    if (route.loadChildren && route?.data?.preload === undefined && route.children) {
      return route.children.some((child) => this.shouldPreloadRoute(child));
    }

    return false;
  }
}
